var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9375mm",
    height: "10.583mm",
    viewBox: "0 0 7.9375 10.583333",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-82.966 -307.58)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 592.9 462.97)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-1927.3-587.31h30v40h-30z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.28)",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    },
    "aria-label": 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1926.3-578.97v4.2155h-4.6712v-4.2155q0-0.95703 0.3646-1.8001 0.3646-0.86589 1.0026-1.4811 0.638-0.63802 1.4811-1.0026 0.8659-0.38737 1.8229-0.38737h14.788q0.9571 0 1.8002 0.38737 0.8658 0.36458 1.4811 1.0026 0.638 0.61523 1.0026 1.4811 0.3874 0.8431 0.3874 1.8001v5.97q0 0.95703-0.1823 1.709-0.1823 0.75195-0.5925 1.3672-0.3874 0.59245-1.0026 1.071-0.6152 0.47851-1.5039 0.91146l-16.178 7.5879v4.7168h15.381v-4.1927h4.6712v8.8639h-24.723v-8.5905q0-0.95703 0.1823-1.709 0.2051-0.75195 0.5924-1.3444 0.3874-0.59245 1.0026-1.071 0.6381-0.5013 1.4812-0.91145l16.201-7.6107v-6.7676z",
    strokeWidth: "1px",
    style: {
      fontFeatureSettings: "normal",
      fontVariantCaps: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.c939e87fb694e426f946b6155136a543.svg";
export { ForwardRef as ReactComponent };